import FontPreloads from './FontPreloads';

export default FontPreloads;
